export const phoneFormat = (phoneNumber) => {
    if (phoneNumber) {
        if (phoneNumber.length < 11) {
            return phoneNumber.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
        }
        return phoneNumber.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    }

    return 'Não Informado';
}

export const cpfFormat = (cpf) => {
    if (cpf) {
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }

    return 'Não Informado';
}

export const dateFormat = (date) => {
    if (date) {
        return date.split('-').reverse().join('/');
    }

    return 'Não Informado';
}

export const dateTimeFormat = (dateTime) => {
    if (dateTime) {
        const [date, time] = dateTime.split(' ');
        const [hour, minute] = time.split(':');
        const timeStr = `${hour}:${minute}`;
        const dateStr = date.split('-').reverse().join('/');

        return `${dateStr} ${timeStr}`;
    }

    return 'Não Informado';
}


// WEBPACK FOOTER //
// ./resources/assets/js/utils/format.js